import { UPDATE_QUALIFICATIONS, RESET_QUALIFY } from '../../mutation-types';

const mutations = {
  [UPDATE_QUALIFICATIONS](state, qualifications) {
    const existingIds = new Set(state.qualifications.map((q) => q.id));
    const newQualifications = qualifications.filter(
      (q) => !existingIds.has(q.id),
    );
    state.qualifications.push(...newQualifications);
  },

  [RESET_QUALIFY](state) {
    state.qualifications = [];
  },
};

export default mutations;
